import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../api/axiosInstance";
import Logo from "../../assets/logosnake.jpg";
import { login } from "../../api/adminAuthApi";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = {
        email,
        password,
      };
      const res = await login(data);
      console.log("login resp:", res);

      if (res?.success) {
        toast.success("OTP sent to your email");

        localStorage.setItem("adminToken", res.data.token);

        // navigate("/Layout/Dashboard");
        navigate("/Layout/Users");
      }
      // navigate("/VerifyEmail", {
      //   state: { email },
      // });

      // navigate("/Layout/Dashboard");
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="right-panel">
        <img className="logo" src={Logo} alt="Snake Slither" />

        <form className="login-card" onSubmit={handleSubmit}>
          <h2>Login</h2>

          <input
            type="email"
            placeholder="Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter Your Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="toggle-eye"
              onClick={() => setShowPassword((p) => !p)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button className="submit-btn" type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Submit"}
          </button>

          <p className="forgot-text">
            Forgot password?
            <NavLink to="/Resetform"> Reset now</NavLink>
          </p>
        </form>
      </div>
    </div>
  );
}
